// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"635f5f07","732":"e4f41ead","977":"40ee0e19"}[chunkId] + ".chunk.js";
};